/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { AppStateResponse, Credentials, EmptyResponse, SessionResponse } from "../models/index";
import {
  AppStateResponseFromJSON,
  CredentialsToJSON,
  EmptyResponseFromJSON,
  SessionResponseFromJSON,
} from "../models/index";
import { getCredentialsHeaders } from "../../../../api/credentials";

export interface LoginRequest {
  credentials?: Credentials;
}

/**
 *
 */
export class SessionApi extends runtime.BaseAPI {
  /**
   * Get pre-authentication configuration data
   */
  async getInitRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<AppStateResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/init`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => AppStateResponseFromJSON(jsonValue));
  }

  /**
   * Get pre-authentication configuration data
   */
  async getInit(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppStateResponse> {
    const response = await this.getInitRaw(initOverrides);
    return await response.value();
  }

  /**
   * Given a valid wdaSessionId, retrieve the representation of a WDA session
   * The static portion of the AppState object (i.e., without a Page)
   */
  async getStaticRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
    sessionId?: string,
  ): Promise<runtime.ApiResponse<AppStateResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/sequenceAnalyzer/session/${sessionId}/isValid`,
        method: "GET",
        headers: { ...headerParameters, ...getCredentialsHeaders() },
        cache: "no-cache",
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => AppStateResponseFromJSON(jsonValue));
  }

  /**
   * Given a valid wdaSessionId, retrieve the representation of a WDA session
   * The static portion of the AppState object (i.e., without a Page)
   */
  async getStatic(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
    sessionId?: string,
  ): Promise<AppStateResponse> {
    const response = await this.getStaticRaw(initOverrides, sessionId);
    return await response.value();
  }

  /**
   * Start a new session.
   * Start a new session
   */
  async loginRaw(
    requestParameters: LoginRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<SessionResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/sessions`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CredentialsToJSON(requestParameters.credentials),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => SessionResponseFromJSON(jsonValue));
  }

  /**
   * Start a new session.
   * Start a new session
   */
  async login(
    requestParameters: LoginRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<SessionResponse> {
    const response = await this.loginRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * End session.
   * End session
   */
  async logoutRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<EmptyResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/sessions`,
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => EmptyResponseFromJSON(jsonValue));
  }

  /**
   * End session.
   * End session
   */
  async logout(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmptyResponse> {
    const response = await this.logoutRaw(initOverrides);
    return await response.value();
  }
}
